import { render } from "./MiniCart.vue?vue&type=template&id=8982bbc6"
import script from "./MiniCart.vue?vue&type=script&lang=js"
export * from "./MiniCart.vue?vue&type=script&lang=js"

import "./MiniCart.vue?vue&type=style&index=0&id=8982bbc6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__